
export const LOCK_USER = 'LOCK_USER';
export const UNLOCK_USER = 'UNLOCK_USER';

export function lockUser() {
    return {
        type: LOCK_USER
    }
}

export function unlockUser(pin) {
    return {
        type: UNLOCK_USER,
        payload: {pin}
    }
}



// WEBPACK FOOTER //
// ./src/common/users/actions.js